import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import { getActiveResult } from '../redux/selectors.js';
import { getQuestionPointTotal, getQuestionSelectedValue } from '../redux/reducers/questions.js';


export default function DebugPanel(props){
  const totalPoints = useSelector( s => s.totalPoints );
  const activeResult = useSelector( getActiveResult );
  const questions = useSelector( s => s.questions );
  const dispatch = useDispatch();
  return <div className="sr-debug-panel">
    <div className="total">Total Points: <strong>{ totalPoints }</strong></div>
    <div className="total">Showing Result: <strong>{ activeResult.id }</strong></div>
    <div className="total">Showing Result selector: <strong>{ activeResult['on-page-element'] }</strong></div>
    <div className="question-summary">
      <strong>Question Summary</strong>
      <ul>
      { questions.map( (q, i) => {
        return <li key={ i } >
          <strong>Question { i + 1 }</strong>- { q.text }<br />
          ID: <strong>{ q.id }</strong><br />
          Total Points: <strong>{ getQuestionPointTotal(q) }</strong><br />
          Value: <strong>{ getQuestionSelectedValue(q) }</strong><br />
        </li>
      })}
      </ul>
     </div>
     <button onClick={ e => {
       dispatch({
         type: 'reset'
       });
     } } >
       Reset
     </button>
  </div>
}